import UserService from '@services/userService';
import { useQuery } from '@tanstack/react-query';

export const useUser = (userId: number | undefined) => {
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => UserService.getOne(userId!),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
